import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { StyleTypeContext } from "../../umbilical_tools";
import { HotelSearchForm } from "../../components/hotels/HotelSearchFormModal";
import { NoScrollContext } from "../../context";
import { Placeholder } from "rsuite";
import Hotel from "../hotels/hotel";
import PropTypes from "prop-types";
import { fetchPackagesPromo } from "../../api";
import { useHistory } from "react-router-dom";
import jssVariables from "../../jss_setup";

const deepHotelStyles = createUseStyles({
  deepHotelContainer: (props) => ({
    width: "100vw",
    height: "100vh",
    display: "grid",
    gridGap: jssVariables.normal_gap,
    justifyItems: "center",
    background: "white",
    position: "fixed",
    overflow: "auto",
    zIndex: 9999,
    placeContent: "center",
    placeItems: "center",
    ...(props?.customStyles?.deepHotelContainer ?? {}),
  }),
  modalPanel: (props) => ({
    boxShadow: jssVariables.shadows.normalShadow,
    width: "95vw",
    zIndex: 9999,
    display: "grid",
    justifyItems: "center",
    gridGap: jssVariables.normal_gap,
    padding: `calc(${jssVariables.normal_gap} * 1)`,
    ...(props?.customStyles?.modalPanel ?? {}),
  }),
  placeholderContainer: (props) => ({
    display: "grid",
    gridGap: `calc(${jssVariables.normal_gap} * 4)`,
    width: "90vw",
    boxShadow: jssVariables.shadows.normalShadow,
    padding: `calc(${jssVariables.normal_gap} * 1)`,
    height: "max-content",
    paddingBottom: `calc(${jssVariables.normal_gap} * 3)`,
    ...(props?.customStyles?.placeholderContainer ?? {}),
  }),
  placeholderContainerHotel: (props) => ({
    boxShadow: jssVariables.shadows.normalShadow,
    borderRadius: "10px",
    padding: jssVariables.normal_gap,
    ...(props?.customStyles?.placeholderContainerHotel ?? {}),
  }),
  placeholderImg: (props) => ({
    borderRadius: "10px 10px 0 0",
    ...(props?.customStyles?.placeholderImg ?? {}),
  }),
  placeholderHoteltext: (props) => ({
    padding: `calc(${jssVariables.normal_gap} * 2) calc(${jssVariables.normal_gap} * 3`,
    ...(props?.customStyles?.placeholderHoteltext ?? {}),
  }),
  placeholderContainerSearchForm: (props) => ({
    padding: `0 calc(${jssVariables.normal_gap} * 1)`,
    ...(props?.customStyles?.placeholderContainerSearchForm ?? {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    deepHotelContainer: (props) => ({
      ...(props?.customStyles?.deepHotelContainer?.smallscreen ?? {}),
    }),
    modalPanel: (props) => ({
      width: "max(25vw, 30rem)",
      ...(props?.customStyles?.modalPanel?.smallscreen ?? {}),
    }),
    placeholderContainer: (props) => ({
      width: "30vw",
      ...(props?.customStyles?.placeholderContainer?.smallscreen ?? {}),
    }),
    placeholderContainerHotel: (props) => ({
      boxShadow: jssVariables.shadows.normalShadow,
      ...(props?.customStyles?.placeholderContainerHotel?.smallscreen ?? {}),
    }),
  },
});
const DeepHotel = ({ hotelReference }) => {
  const history = useHistory();
  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const customStyles = cStyler({ type, brand, objName: "deepHotel" });
  const classes = deepHotelStyles({ customStyles });

  const { toggleNoScroll } = useContext(NoScrollContext);
  useEffect(() => {
    toggleNoScroll(true);
    return () => toggleNoScroll(false);
  }, []);

  const [loading, setLoading] = useState(true);
  const [hotelData, setHotelData] = useState({});

  useEffect(() => {
    fetchPackagesPromo({
      references__in: hotelReference,
    }).then((hotelsResult) => {
      if (hotelsResult.length > 0) {
        const tempHotel = hotelsResult.find(
          (htl) => htl.reference === hotelReference
        );
        if (tempHotel) {
          setHotelData(tempHotel.accommodation_data[`1`][0]);
        } else {
          history.push("/404/");
        }
      }
    });
  }, []);

  useEffect(() => {
    if (!_.isEmpty(hotelData)) setLoading(false);
  }, [hotelData]);

  return (
    <div className={classes.deepHotelContainer}>
      {loading ? (
        <div className={classes.placeholderContainer}>
          <div className={classes.placeholderContainerSearchForm}>
            <Placeholder.Paragraph rows={3} active />
            <Placeholder.Paragraph rows={3} active />
            <Placeholder.Paragraph rows={2} active />
          </div>
          <div className={classes.placeholderContainerHotel}>
            <Placeholder.Graph active />

            <Placeholder.Paragraph
              rows={6}
              className={classes.placeholderHoteltext}
              active
            />
          </div>
        </div>
      ) : (
        <div className={classes.modalPanel}>
          <HotelSearchForm
            hotelId={hotelData.metadata.id}
            onCancel={() => history.push("/")}
            isInDeepHotel={true}
          />
          <Hotel
            hotel={hotelData}
            ghost={false}
            isInLandingPage={true}
            type={type}
            mobileViewOnly={true}
            withPrice={false}
            showBottomContainer={false}
            showImg={false}
            extraCustomStyles={{
              imgContainer: { display: "none", smallscreen: {} },
              addressMapIconContainer: {
                display: "none",
                smallscreen: { display: "none" },
              },
            }}
          />
        </div>
      )}
    </div>
  );
};
DeepHotel.defaultProps = { hotelReference: "" };
DeepHotel.propTypes = { hotelReference: PropTypes.string.isRequired };
export default DeepHotel;
